import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { showNotification, hideNotification } from '../Actions/Notification';
import './Notification.scss';

class Notification extends PureComponent {
  state = {
    affixTop: true
  };

  componentDidMount() {
    this.scrollMonitor();
    window.addEventListener('scroll', () => this.scrollMonitor);
  }

  componentDidUpdate() {
    this.hideNotification();
  }

  hideNotification() {
    if (this.props.autoHide) {
      setTimeout(
        () => this.props.hideNotification(),
        this.props.autoHideDelay || 3000
      );
    }
  }

  scrollMonitor() {
    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 65) {
        this.setState({ affixTop: false });
      } else {
        this.setState({ affixTop: true });
      }
    });
  }

  render() {
    let classes = ['notification'];
    classes.push(
      this.props.type
        ? 'notification-' + this.props.type
        : 'notification-success'
    );
    const showClass = 'show-notification';

    if (this.props.show) {
      classes.push(showClass);
    } else {
      if (classes.includes(showClass)) {
        const index = classes.indexOf(showClass);
        classes.splice(index, 1);
      }
    }

    if (this.state.affixTop) {
      classes.push('affix-top');
    }

    return (
      <div className={classes.join(' ')}>
        <div className="notification-body">
          {this.props.message}
          <i
            className="fa fa-times"
            aria-hidden="true"
            onClick={this.props.hideNotification}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    show: state.notificationReducer.show,
    type: state.notificationReducer.notificationType,
    message: state.notificationReducer.message,
    autoHide: state.notificationReducer.autoHide,
    autoHideDelay: state.notificationReducer.autoHideDelay
  };
};

const mapDispatchToProps = dispatch => {
  return {
    hideNotification: () => dispatch(hideNotification()),
    showNotification: () => dispatch(showNotification())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Notification);



// WEBPACK FOOTER //
// ./src/Component/Notification.js